import React, { useState } from 'react';

// Pied de page commun (app + test de niveau) : ligne de soutien + « ? » vers la page
// à propos. `children` = contenu optionnel placé en tête (ex. le bouton compte de
// l'app). Plus de liens vers les autres versions du site (retirés à la demande).

export default function Footer({ lang, children }) {
  const [btcCopied, setBtcCopied] = useState(false);
  return (
    <footer className="text-center mt-10 text-slate-500 border-t border-slate-700 pt-5 pb-4 flex flex-col gap-2">
      {children}

      <p className="text-xs text-slate-600">
        {lang.ui.supportLine}{' '}
        <a href="mailto:russian.overnight765@passmail.net" className="hover:text-slate-400 transition-colors underline">
          Mail
        </a>
        {' · '}
        <a href="https://donate.stripe.com/7sYdR94ow403eIr4MZ5ZC01" target="_blank" rel="noopener noreferrer" className="hover:text-slate-400 transition-colors underline">
          {lang.ui.supportCard}
        </a>
        {' · '}
        <button
          onClick={() => navigator.clipboard.writeText('bc1qztsuxjavu6wmhp68fs3ert6wv0j0r6t8jdseh2').then(() => { setBtcCopied(true); setTimeout(() => setBtcCopied(false), 2000); }).catch(() => {})}
          className="hover:text-slate-400 transition-colors underline"
          title="bc1qztsuxjavu6wmhp68fs3ert6wv0j0r6t8jdseh2"
        >
          {btcCopied ? '✓ BTC' : 'BTC'}
        </button>
      </p>

      <a
        href={lang.ui.aboutUrl}
        title={lang.ui.about}
        aria-label={lang.ui.about}
        className="text-sm text-slate-700 hover:text-slate-500 transition-colors mt-1"
      >
        ?
      </a>
    </footer>
  );
}
